module.exports = __webpack_public_path__ + "static/img/technology-2.acd9dd31.png";